import React, { isValidElement } from 'react'
import Typography from '../../Typography'
import styles from './index.module.css'
import { findOneByName } from '@s4l/utils/library/react'
import type { UtilityClassNames } from '@s4l/utility-css'
import { cn } from '@s4l/utility-css'

interface ILabelProps {
  children: React.ReactNode
  className?: UtilityClassNames
}

const Label = ({ children, className }: ILabelProps) => {
  const childrenArray = React.Children.toArray(children)

  const inputElement =
    findOneByName(childrenArray, 'Form.Input') || findOneByName(childrenArray, 'Form.TextArea')

  const textContent = childrenArray.filter(
    child => typeof child === 'string' || (isValidElement(child) && typeof child.type === 'string')
  )

  const sliderElement = findOneByName(childrenArray, 'Form.Slider')

  const checkboxElement = findOneByName(childrenArray, 'Form.Checkbox')

  const radioButtonElement = findOneByName(childrenArray, 'Form.RadioButton')

  const nonTextElements = childrenArray.filter(child => {
    if (typeof child === 'string') return false
    if (!isValidElement(child)) return true

    if (typeof child.type === 'string') return false

    const displayName = (child.type as any)?.displayName
    return ![
      'Form.Input',
      'Form.TextArea',
      'Form.Slider',
      'Form.Checkbox',
      'Form.RadioButton',
    ].includes(displayName)
  })

  if (inputElement) {
    return (
      <div className={cn(styles.floatingLabel, className)}>
        {inputElement}
        <label className={styles.floatingLabelText}>
          <Typography as="span" variant="body" size="l">
            {textContent}
          </Typography>
        </label>
      </div>
    )
  }

  if (sliderElement) {
    return (
      <label className={styles.labelText}>
        <Typography as="div" variant="body" size="l" className="mb-24">
          {textContent}
        </Typography>
        {sliderElement}
      </label>
    )
  }

  const formControlElement = checkboxElement || radioButtonElement

  return (
    <label className={cn(styles.label, className)}>
      {formControlElement}
      <Typography as="span" variant="body" size="l" className="flex-grow-1">
        {textContent}
      </Typography>
      {nonTextElements}
    </label>
  )
}

Label.displayName = 'Form.Label'
export default Label
